"use client";

import { useEffect, useState } from "react";

const MD_UP = "(min-width: 768px)";

/**
 * Matches Tailwind `md`. Defaults to `true` for SSR + first paint so the server tree matches hydration;
 * updates on mount and on viewport changes.
 */
export function useIsMdUp(): boolean {
	const [matches, setMatches] = useState(true);
	useEffect(() => {
		const mq = window.matchMedia(MD_UP);
		const sync = () => setMatches(mq.matches);
		sync();
		mq.addEventListener("change", sync);
		return () => mq.removeEventListener("change", sync);
	}, []);
	return matches;
}
